import { combineReducers, Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import toastReducer from '../components/Toast/Store';
import tradeReducer from '../pages/TradeManagement/Store';
import keywordsReducer from '../pages/TradeManagement/Store/keywords';
import projectReducer from '../pages/ProjectManagement/Store';
import projectDetailsReducer from '../pages/ProjectDetails/Store';
import profileReducer from '../pages/Profile/Store';
import loginReducer from '../pages/Login/Store';
import userReducer from '../pages/UserManagement/Store';
import dashboardReducer from '../pages/Dashboard/Store';
import productOwnerReducer from '../pages/ProductOwner/Store';
import subscriptionPlanReducer from '../pages/SubscriptionPlan/Store';
import enterprisePlanReducer from '../pages/EnterprisePlan/Store';
import organizationReducer from '../pages/Organization/Store';
import promptsReducer from '../pages/TradeManagement/Store/prompts';

const reducers = {
	tradeStore: tradeReducer,
	toastStore: toastReducer,
	keywordsStore: keywordsReducer,
	projectStore: projectReducer,
	projectDetailsStore: projectDetailsReducer,
	profileStore: profileReducer,
	loginStore: loginReducer,
	userStore: userReducer,
	dashboardStore: dashboardReducer,
	productOwnerStore: productOwnerReducer,
	subscriptionPlanStore: subscriptionPlanReducer,
	enterprisePlanStore: enterprisePlanReducer,
	organizationStore: organizationReducer,
	promptsStore: promptsReducer,
};

const appReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof appReducer>;

export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;

export default appReducer;
